module.exports = __webpack_public_path__ + "img/businessman.d12df58f.jpeg";